<header id="home-header" [ngClass]="{ 'header-fixed': isFixed }">
  <div class="container">
    <!-- Logo -->
    <div class="home-logo">
      <a routerLink="/">
        <img
          ngSrc="assets/images/logo_with_name_351x84-v4.webp"
          alt="Habit Heroes logo"
          width="351"
          height="84"
          loading="lazy"
          fetchpriority="auto"
          srcset="
            assets/images/logo_with_name_351x84-v4.webp    351w,
            assets/images/logo_with_name_700x168-v4.webp   700w,
            assets/images/logo_with_name_1269x303-v4.webp 1269w
          "
          sizes="
            (max-width: 600px) 117px,
            (max-width: 1200px) 351px,
            700px
          "
        />
      </a>
    </div>

    <!-- Hamburger Button -->
    <button
      class="menu-toggle"
      (click)="menuOpened = !menuOpened"
      aria-label="Toggle menu"
    >
      <mat-icon>{{ menuOpened ? "close" : "menu" }}</mat-icon>
    </button>

    <!-- Navigation -->
    <nav [class.open]="menuOpened">
      <!-- Haupt-Links (direkt nach Logo) -->
      @if (loggedIn) {
      <a
        routerLink="/start"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Get Started
      </a>
      } @if (!loggedIn) {
      <a
        routerLink="/pricing"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Pricing
      </a>
      } @if (!loggedIn) {
      <a
        routerLink="/how-it-works"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        How It Works
      </a>
      } @if (!loggedIn) {
      <a
        routerLink="/template"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Template
      </a>
      } @if (loggedIn) {
      <a
        routerLink="/competition"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Competitions
      </a>
      } @if (loggedIn) {
      <a
        routerLink="/duel"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Duel
      </a>
      }
      <!--
        Groups are B2B-only (backlog #316): only show this link once we know
        the logged-in user actually belongs to a group (hasGroups, refreshed
        from GET /group/mine) - most users have none and shouldn't see it.
      -->
      @if (loggedIn && hasGroups) {
      <a
        routerLink="/groups"
        routerLinkActive="active"
        (click)="menuOpened = false"
        class="groups-link"
        aria-label="Your groups"
      >
        <mat-icon>groups</mat-icon>
        <span class="link-label">Your groups</span>
      </a>
      }

      <a
        routerLink="/blog"
        routerLinkActive="active"
        (click)="menuOpened = false"
      >
        Blog
      </a>

      <div class="nav-spacer"></div>

      <!-- Login/Account Links (rechts) -->
      @if (loggedIn) {
      <a
        routerLink="/profile"
        routerLinkActive="active"
        (click)="menuOpened = false"
        class="user-link"
      >
        <mat-icon>person</mat-icon>
        <span class="user-email">{{ loggedInEmail }}</span>
      </a>
      <a
        routerLink="/feedback"
        routerLinkActive="active"
        (click)="menuOpened = false"
        class="feedback-link"
        aria-label="Feedback"
      >
        <mat-icon>feedback</mat-icon>
        <span class="link-label">Feedback</span>
      </a>
      <a (click)="logout(); menuOpened = false" class="logout-link"> Logout </a>
      } @else {
      <a
        routerLink="/register"
        class="signup-cta"
        (click)="menuOpened = false; trackSignupCtaClick()"
        >Get started</a
      >
      <a
        routerLink="/login"
        routerLinkActive="active"
        (click)="menuOpened = false"
        class="account-link"
      >
        <mat-icon>person</mat-icon>
        My Account
      </a>
      }
    </nav>

    <!-- Overlay -->
    @if (menuOpened) {
    <div class="menu-overlay" (click)="menuOpened = false"></div>
    }
  </div>
</header>
